import React from "react";
import styled from "styled-components";
import LinearProgress from "@mui/material/LinearProgress";
import { FileUploadProgressingProps } from "./types";
import { Column, Columns, Text } from "@origin-digital/ods-core";

const StyledLinearProgress = styled(LinearProgress)`
  && {
    background-color: #e0e0e0;
    .MuiLinearProgress-bar {
      background-color: #f4b74f;
      border-radius: 5px;
    }
  }
  height: 6px;
  border-radius: 5px;
`;

const StyledColumn = styled(Column)`
  width: 56px;
`;

export const FileUploadProgressing: React.FC<FileUploadProgressingProps> = ({
  file,
}) => {
  return (
    <Columns space="xsmall" alignY="center">
      <Column>
        <StyledLinearProgress variant="determinate" value={file.progress} />
      </Column>
      <StyledColumn>
        <Text>{file.progress}%</Text>
      </StyledColumn>
    </Columns>
  );
};
